export const ONBOARDING_EXPERIMENT_THIRD_ARM = {
  production: {
    experimentId: '18975350203',
    variantId: '18910631794',
  },
  stagingAndDev: {
    experimentId: '18910262090',
    variantId: '18920542519',
  },
};

const isOptimizelyLoaded = () => typeof window.optimizely.get === 'function';

const isBucketedInOptimizelyVariant = (experimentId, variantId) => {
  if (!isOptimizelyLoaded()) {
    return false;
  }
  const optimizelyState = window.optimizely.get('state');
  // This occurs when running branch=local not sure if a production issue
  if (optimizelyState === undefined) {
    return false;
  }
  const mapExperimentsToVariant = optimizelyState.getVariationMap();
  const onboardingExperimentVariant = mapExperimentsToVariant[experimentId] || {};
  return onboardingExperimentVariant.id === variantId;
};

export default isBucketedInOptimizelyVariant;
